/**
 * NextAuth credential-provider ids, in a dependency-free module.
 *
 * These are imported by both the server config (`@/lib/auth`) and the client
 * `signIn` wrappers (`auth-client`). Keeping them here — rather than on
 * `@/lib/auth` — stops the client bundle from pulling in the NextAuth *server*
 * SDK + `authOptions` just to read two strings (it otherwise added ~250 kB to
 * every page that signs in).
 */
export const USER_CREDENTIALS_PROVIDER = "credentials";
export const ADMIN_CREDENTIALS_PROVIDER = "AdminCredentials";
